var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Team Page"},[_c('div',{staticClass:"Team__text",domProps:{"innerHTML":_vm._s(_vm.page[_vm.lang].text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }